"use client";

import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

export default function InstagramFeed({ limit = 10 }) {
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchInstagramPosts() {
      try {
        const response = await fetch(`/api/instagram?limit=${limit}`);
        const data = await response.json();

        if (response.ok) {
          setPosts(data.data || []);
        } else {
          throw new Error(data.error || "Failed to fetch posts");
        }
      } catch (err) {
        setError(err.message);
      }
    }

    fetchInstagramPosts();
  }, [limit]);

  if (error) return <p className="text-red-500"></p>;

  return (
    <div className="">
      <h3 className="font-serif mt-10 px-4 text-2xl md:text-3xl font-normal mb-4 pt-4 text-left">
        <Link href="#" className="text-left hover:text-primary">
          Follow us on instagram <span className="font-bold">@poshandcake</span>
        </Link>
      </h3>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 p-4  mx-auto overflow-y-auto">
        {posts.length > 0 ? (
          posts.map((post) => (
            <Link
              key={post.id}
              href={post.permalink}
              target="_blank"
              rel="noopener noreferrer"
              className="block group relative"
            >
              <Image
                src={
                  post.media_type === "VIDEO"
                    ? post.thumbnail_url
                    : post.media_url
                }
                alt={post.caption || "Instagram post"}
                width={500}
                height={500}
                className="h-64 lg:h-72 2xl:h-96 w-full object-cover rounded-lg"
                unoptimized
              />
              {/* Overlay effect on hover */}
              <div className="absolute inset-0 bg-black bg-opacity-20 opacity-0 group-hover:opacity-100 transition-opacity" />
              {/* Icon for media type */}
              <div className="absolute top-2 left-2 text-white">
                <Icon
                  icon={
                    post.media_type === "VIDEO"
                      ? "clarity:video-gallery-solid"
                      : "clarity:image-gallery-solid"
                  }
                  className="w-6 h-6"
                />
              </div>
            </Link>
          ))
        ) : (
          <p className="col-span-full text-center text-gray-500">
            Loading instagram posts...
          </p>
        )}
      </div>
    </div>
  );
}
